import moment from "moment";

import { RangeModeTypes } from "../../../types";
import { RangeMode } from "../bookings_view/bookings_view";

const ONE_DAY_MILLIS = 1000 * 60 * 60 * 24;

export const MODE_TO_DAYS = {
  [RangeModeTypes.Day]: 1,
  [RangeModeTypes.Week]: 7,
  [RangeModeTypes.TwoWeeks]: 14,
  [RangeModeTypes.Month]: 31,
  [RangeModeTypes.Quarter]: 3 * 31
};

export const getModeDays = (rangeMode: RangeMode, utc): number => {
  if (rangeMode.type === RangeModeTypes.Custom) {
    return moment.duration(utc(rangeMode.end).diff(rangeMode.start)).asDays() + 1;
  } else {
    return MODE_TO_DAYS[rangeMode.type];
  }
};

export const addOneDay = (dateObject: Date) => {
  dateObject.setDate(dateObject.getDate() + 1);
  return dateObject;
};

export const isDateBetween = (targetDate: Date, startDate: Date, endDate: Date) =>
  targetDate >= startDate && targetDate <= endDate;

export const getDaysDifference = (date1: Date, date2: Date) => {
  const timeDifference = date2.getTime() - date1.getTime();
  return timeDifference / ONE_DAY_MILLIS;
};

export const getStartOfDay = (date: string) => {
  const dateObject = new Date(date);
  dateObject.setUTCHours(0, 0, 0);
  return dateObject;
};

export const getEndOfDay = (date: string) => {
  const dateObject = new Date(date);
  dateObject.setUTCHours(23, 59, 59);
  return dateObject;
};
